import dayjs from 'dayjs';
import { useNoteStyles } from './note.styles';
import { StatusBadge } from '../status-badge/status-badge.component';
import { Colors } from '../../../theme/colors';
import {
  NoteEntityRelationship,
  NoteEntityRelationshipProps
} from '../notes-entity-relationship/entity-relationship.component';

export interface NoteProps {
  date: string;
  user?: string;
  internal?: boolean;
  content: string;
  child?: NoteEntityRelationshipProps;
}

export function Note({ date, user, internal = false, content, child }: NoteProps) {
  const classes = useNoteStyles();
  const formatted = dayjs(date).format('DD-MM-YYYY @ h:mma');

  return (
    <div className={classes.root}>
      {internal && (
        <StatusBadge
          className={classes.badge}
          color={Colors.informativeYellow}
          fontColor={Colors.burntOrange}
          fontSize="10px"
          label={'internal'}
          cornerRounding="min"
          collapse="wrap-text"
          inline={true}
          uppercase
          showTooltip={false}
          tooltipPlacement="bottom"
        />
      )}

      <div className={classes.content}>{content}</div>
      <div className={classes.footer}>
        {formatted}
        {user ? ` | ${user}` : null}
      </div>
      {child ? (
        <div className={classes.child}>
          <NoteEntityRelationship {...child} />
        </div>
      ) : null}
    </div>
  );
}
